// extracted by mini-css-extract-plugin
module.exports = {"block":"_4679","title":"_917","content":"_19668"};